import React, { Component } from 'react';
import WishListView from './WishListView';
import {url} from "../../../Server/url/GlobalUrl"

class WishListComponent extends Component {
		state = {
			"data":[],
			 expand:'none',
			 expand_id: '',
			 modal_show: false,
			 authResponse:"",
			 card:true,
			 card_active:'active',
			 list_active:'',
			 apply_modal_show: false,
			 applied_job_id:'', 
			applied_shift_id:[],    
			change_place:false,
			apply_job_check:false, 
			qualification:[],
			shift_select_timing : [],
		}


		api = () =>{
	  
         }
         data = this.api();


		 handelShift = (id,checked) => {
			console.log('shift  id',id,checked);
			if (id === "all"){
				if (checked){
					var i;
					for (i = 0; i < this.state.shift_select_timing.length; i++) {
						this.state.applied_shift_id.push(this.state.shift_select_timing[i].shift_id)
						this.setState({applied_shift_id: this.state.applied_shift_id});
					}
					console.log('this.state.applied_shift_id',this.state.applied_shift_id)
				}else{
					this.state.applied_shift_id.splice(0, this.state.applied_shift_id.length);
					this.setState({applied_shift_id: this.state.applied_shift_id});
					console.log('this.state.applied_shift_id',this.state.applied_shift_id)
				}
	
		}else{
			if(this.state.applied_shift_id.length ===  this.state.shift_select_timing.length){
				return
			}
			if (checked){
			this.state.applied_shift_id.push(id)
			this.setState({applied_shift_id: this.state.applied_shift_id});
			}else{
				var index = this.state.applied_shift_id.map(x => {
					return x.Id;
				  }).indexOf(id);
				  console.log('id',id)
				  this.state.applied_shift_id.splice(index, 1);
				  this.setState({applied_shift_id: this.state.applied_shift_id});
			}
		}
			console.log('this.state.applied_shift_id',this.state.applied_shift_id)
	
		}
	


		 applyHideCustomModal = () => {
			this.setState({ apply_modal_show: false })
		
		  }
	
		  applyShowCustomModal = (id) => {
			  console.log('id', id)
			this.setState({apply_job_check:true})
			  if (localStorage.getItem('token')) {
				let auth = localStorage.getItem("token");
				fetch(( url  + "/jobs/job-shifts/?job_id=" + id), {
					method: 'GET',
					headers: {
						'Accept': "application/json",
						'Content-Type': "application/json",
						'Authorization': 'Bearer ' + auth,
			
						
					},
					})
				  .then(res => res.json())
				  .then(
					(result) => {
						console.log('result',result)
		
						if (result.length > 0){
							var j;
							for (j of result){
								
								 var start_string =  j.start_repeate + ' begins ' + j.start_date + ' from ' + j.start_date_arrival_time + ' to ' + j.start_date_departure_time
								//  var end_string = j.end_quantity + ' Nurses' + ' ' +  j.end_repeate + ' begins ' + j.end_date + ' from ' + j.end_date_arrival_time + ' to ' + j.end_date_departure_time
								 j['start_string'] = start_string
								//  j['end_string'] = end_string
								console.log('shifts.length',j)
								this.state.applied_shift_id.push(j.shift_id)
								this.setState({applied_shift_id:this.state.applied_shift_id})
								}
						}
	
						this.setState({shift_select_timing:result, applied_job_id: id})
						if(result.length===1) {
							this.handelShift(result[0].id);
							this.applyjob();
						}
						else {
							this.setState({apply_modal_show: true})
						}
		
					  
					},
					(error) => {
					  console.log('error',error)
					})
		
			
		
				
			  } else{
				window.location.replace('/login')
			}
	
			  
		  }


         hideCustomModal = () => {
        	this.setState({ modal_show: false })
			if(this.state.change_place){
				window.location.replace("/registration/submit-cv");
			}
     	 }

	     showCustomModal = () => {
	        this.setState({ modal_show: true })
	    }


         componentDidMount(){


        let auth = localStorage.getItem("token");
        let user = localStorage.getItem("cv-id");
		fetch(url + "/jobs/wishlist/?user="+user ,{
		method:"GET",
		headers: {
		    'Accept': "application/json",
		    'Content-Type': "application/json",
		    'Authorization': 'Bearer ' + auth,

		    
		},
	    })
		.then((response) => {
		    // console.log("Response", response.json())
		    return response.json()
		    
		    // console.log(this.state.data);
		    if(response['status'] === 201 || response['status'] === 200){

		    }
		})
		    .then((data) =>{
				if(data){
		    		this.setState({"data":data});
		    		console.log(data);
				}

		    })

		      .catch((err) => {
		        console.log("ERROR",err.body);
		    })

			fetch((url + "/jobs/qualification/"), {
				method: 'GET'
				})
			  .then(res => res.json())
			  .then(
				(result) => {
				
				  this.setState({qualification: result})
				  console.log('qualification',result)
				},
				(error) => {
				  console.log('error',error)
				})



         }

		 applyjob = async () => {
			let id = this.state.applied_job_id;
			this.applyHideCustomModal()
			console.log('shift id', this.state.applied_shift_id)
			console.log('job id', this.state.applied_job_id)
			if (localStorage.getItem('token')){
		 
			let data = {
				'job' : this.state.applied_job_id,
				'shift' : this.state.applied_shift_id[0],
						}
			console.log("Data",JSON.stringify(data));
			let auth = localStorage.getItem("token")
			await fetch(url + '/jobs/user-applied-jobs/', {
			method: 'POST',
			headers: {
			   'Accept': 'application/json',
			  'Content-Type': 'application/json',
			  'Authorization': 'Bearer ' + auth,
			},
			body: JSON.stringify(data)
			})
			.then((response) => {
				console.log("response", response)
				if (response['status'] === 201 || response['status'] === 200) {
					this.showCustomModal()
					this.setState({authResponse:'You Have applied to job successfully '})
					return response.json()
				} else if (response['status'] === 400 || response['status'] === 401) {
						this.showCustomModal()
						this.setState({authResponse:'Some thing went wrong please try again '})
				}
				else if(response['status'] === 406){
					this.showCustomModal();
				}
				else if(response['status'] == 500){
					this.showCustomModal();
					this.setState({authResponse:"Server Problem"});
					return;
				}
				return response.json()
			})
			.then((result) => {
				if(result['error']){
					this.setState({authResponse:result['error']});
					if(result.error === "You are not assigned a role of candidate"){
						this.setState({change_place:true})
					}

				}
			})
			.catch((err) => {
				console.log('err',err);
			})
			}else{
				window.location.replace('/login')
			}
		}

		
		
 return_string_data = (ids) => {
             console.log(ids)
             if(!ids){
                 return;
             }
            var result = []
              for(var each of this.state.qualification){
                  for(var id of ids){
                        if(each.id == id){
                            // console.log(id,each.id);
                            if(!result.includes(each.type)){
                                result.push(each.type)
                            }
                        }
                  }
              }
              return result.join(",")
          }



    handelcompression = (id) => {
        console.log('id',id)
            if (this.state.expand_id === id){
                if (this.state.expand == 'block'){
                    this.setState({expand : 'none'})
                    this.setState({expand_id : id})
                   }else{
                        this.setState({expand : 'block'})
                   }
            }else{
                  this.setState({expand : 'block'})
                  this.setState({expand_id : id})
            }
      }
    removeFromFavourites = (id) =>{
      
        console.log(id);
        let auth = localStorage.getItem("token");
		// let user = localStorage.getItem("cv-id")
		this.setState({apply_job_check:false});
        fetch(url + "/jobs/wishlist/"+id+"/",{
        method:"DELETE",
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json",
            'Authorization': 'Bearer ' + auth,

            
        },
        })
        .then((response) => {
            // console.log("Response", response.json())
            console.log(response);
            if(response['status'] === 204 || response['status'] === 200){
            	this.state.data = this.state.data.filter((each) => each.id != id)
            	this.setState({data: this.state.data});
                this.showCustomModal()
                this.setState({authResponse:"Removed from  the favourites"});
      
            }
        })
            // .then((data) =>{
            //     this.showCustomModal()
            //     this.setState({authResponse:"Removed from  the favourites"});
            //     console.log(data);
            // })

              .catch((err) => {
                 this.showCustomModal()
                this.setState({authResponse:"Error While Removing to favourites"});
                console.log("ERROR",err);
            })
		 }
		 
		 handelFormat = () => {
			console.log('yes i am in')
			if (this.state.card){
				this.setState({
					card: false,
					list_active : 'active',
					card_active : '',
				})
			}else{
				this.setState({
					card: true,
					card_active : 'active',
					list_active : '',
				})
	
			}
		 }

	    render() {
	   
		return <WishListView 
			data ={this.state.data}
			expand={this.state.expand}
            expand_id={this.state.expand_id}
            handelcompression={this.handelcompression}
            removeFromFavourites = {this.removeFromFavourites}
            hideCustomModal={this.hideCustomModal}
            showCustomModal={this.showCustomModal}
            modal_show={this.state.modal_show}
            authResponse = {this.state.authResponse}
			applyjob = {this.applyjob}
			handelFormat={this.handelFormat}
			return_string_data={this.return_string_data}
			card={this.state.card}
			list_active={this.state.list_active}
			card_active={this.state.card_active}
			shift_select_timing={this.state.shift_select_timing}
            applied_shift_id={this.state.applied_shift_id}
			handelShift={this.handelShift}
			applyHideCustomModal={this.applyHideCustomModal}
			applyShowCustomModal={this.applyShowCustomModal}
			apply_job_check={this.state.apply_job_check}
			apply_modal_show={this.state.apply_modal_show}
		/>
	    }
}

export default WishListComponent;
